export default __webpack_public_path__ + "static/media/bgEmail.863f9b02.webp";